import { MARKET } from '../types';

const getMarket = (args) => {
    let market =
        args.customerType && MARKET[args.customerType.toUpperCase()]
            ? MARKET[args.customerType.toUpperCase()]
            : 'brak';
    if (market === 'brak' && args.chatChannel) {
        market = MARKET[args.chatChannel.toUpperCase()]
            ? MARKET[args.chatChannel.toUpperCase()]
            : 'brak';
    }
    args.tags &&
        args.tags.forEach((t) => {
            if (t.toUpperCase().includes('B2B')) {
                market = 'B2B';
            } else if (t.toUpperCase().includes('B2C')) {
                market = 'B2C';
            }
        });
    return market;
};

const getTags = (initTags, PROCESS_TAGS, market, isMOApp, loginType = 'none', name) => {
    let tags = initTags || [];

    let processTag;
    if (isMOApp) {
        processTag =
            PROCESS_TAGS[(market + '_' + loginType + '_APP' + (name ? '_N' : '')).toUpperCase()];
    } else {
        processTag = PROCESS_TAGS[(market + '_WWW').toUpperCase()];
    }

    if (processTag) {
        tags = tags.concat(processTag.split(','));
    }

    return tags;
};

export { getMarket, getTags };
